import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface WorkflowChartProps {
  data?: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
    }>;
  };
}

const WorkflowChart: React.FC<WorkflowChartProps> = ({ data }) => {
  const defaultData = {
    labels: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00'],
    datasets: [
      {
        label: 'Completed',
        data: [12, 19, 15, 25, 22, 30],
        borderColor: 'rgb(34, 197, 94)',
        backgroundColor: 'rgba(34, 197, 94, 0.1)',
      },
      {
        label: 'Failed',
        data: [2, 3, 1, 5, 3, 2],
        borderColor: 'rgb(239, 68, 68)',
        backgroundColor: 'rgba(239, 68, 68, 0.1)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          color: '#a1a1aa', // zinc-400
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: 'Workflow Activity',
        color: '#ffffff',
        font: {
          size: 16,
          weight: 'bold' as const,
        },
      },
      tooltip: {
        backgroundColor: 'rgba(24, 24, 27, 0.9)',
        titleColor: '#ffffff',
        bodyColor: '#a1a1aa',
        borderColor: 'rgba(63, 63, 70, 0.5)',
        borderWidth: 1,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(63, 63, 70, 0.2)',
          drawBorder: false,
        },
        ticks: {
          color: '#71717a', // zinc-500
        },
      },
      x: {
        grid: {
          color: 'rgba(63, 63, 70, 0.2)',
          drawBorder: false,
        },
        ticks: {
          color: '#71717a', // zinc-500
        },
      },
    },
  };

  return (
    <div className="h-full">
      <h2 className="text-xl font-semibold mb-4 text-white">Workflow Metrics</h2>
      <div className="h-64">
        <Line options={options} data={data || defaultData} />
      </div>
    </div>
  );
};

export default WorkflowChart;